import icon from "../../assets/opticzoom.svg";
import type { Property } from "../../types";

export const opticalZoom: Property = {
  id: "opticalZoom",
  title: "opticalZoom.title",
  icon,
};
